import { isCoreClassifier } from './isCoreClassifier'
import { ClassifierInterface } from './types'

/**
 * Keeps any classifiers whose type is considered core.
 * @param {ClassifierInterface[]} classifiers - Array of classifier objects to filter.
 * @returns {ClassifierInterface[]} A new array including classifiers for which `isCoreClassifier(type)` is true.
 */
export function keepCoreClassifiers(classifiers: ClassifierInterface[]): ClassifierInterface[] {
  return (Array.isArray(classifiers) ? classifiers : []).filter((classifier) =>
    isCoreClassifier(classifier.type),
  )
}
